import { RootState } from '../../../store';

export const getStocks = (state: RootState) => state.stock.stock;
export const getWarehouses = (state: RootState) => state.stock.warehouses;